import { createContext } from 'react';

export default createContext({
  name: '',
  preventFallbackToGlobals: false,
});
